import { DynamicColumnTable } from "@/components/organisms";
import { getMappedCellDataForOnlineItems } from "@/helpers/onlineItemsUtility";
import { useOnlineItemOrderData } from "@/services/onlineOrderItemService";

export const OnlineItemsList = () => {

    const {
        rowData,
        colConfig,
        isLoading,
        isError
    } = useOnlineItemOrderData();

    if (isError) {
        return "Error Loading the data from API"
    }


    if (isLoading) {
        return "Loading Table Data "
    }
    

    const cellDataMappedCols = getMappedCellDataForOnlineItems(colConfig);
    return <DynamicColumnTable
        pklass={`font-normal text-balance`}
        columns={cellDataMappedCols}
        records={rowData?.items || []}
        isDark={true}
        tableDescription=""
        tableHeader=""
    />
}



